import { css } from "@emotion/react";

export function buro2CSS(){
    return css`
        display: flex;
        flex-direction: column;
        align-items: center;

        .FormContainer{
            width: 100%;
            padding: 0 30vw;

            .Column{
                display: flex;
                align-items: center;
            }

            .BlackText{
                color: #000;
                font-family: 'Neue Haas Grotesk Display Pro';
                font-size: calc(0.3rem + 0.8vw);
                font-style: normal;
                font-weight: 500;
            }

            .IconContainer{
                justify-content: center;

                .SelectionDiv{
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    gap: 0.3rem;

                    border: 1px solid #34C6F1;
                    border-radius: 12px;
                    padding: 0.3rem 0.9rem;

                    span{
                        color: #34C6F1;
                        text-align: center;
                        font-family: 'Neue Haas Grotesk Display Pro';
                        font-size: calc(0.3rem + 0.6vw);
                        font-style: normal;
                        font-weight: 500;
                    }

                    img{
                        margin-top: 3px;
                        height: calc(0.8rem + 1.2vw);
                    }

                }

                .Selected{
                    background-color: #34C6F1;
                }
            }

            .Paragraph{
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                margin-top: 1rem;
                margin-bottom: 1rem;
                
            }

            .Disclaimer{
                color: #77787B;
                font-family: 'Neue Haas Grotesk Display Pro';
                font-size: calc(0.5rem + 0.5vw);
                font-style: normal;
                font-weight: 500;
                text-align: justify;
                //line-height: 20px; /* 125% */
            }

            .CheckboxRow{
                margin-top: 1rem;
                display: flex;
                gap: 4%;
            }

            .ButtonWithShadow{
                display: flex;
                flex-direction: column;
                width: fit-content;
                gap: 2rem;

                .Green{
                    background-color: #1FDD8F;
                    color: white;
                    font-size: calc(0.4rem + 0.7vw);
                    border-radius: 17px !important;
                    border: unset !important;
    
                    width: fit-content;
                    padding: 0 6rem;
                    :hover{
                        background-color: #2ad690;
    
                    }
                }
                .Shadow{
                    width: 100%;
                    height: 55px;
                    border-radius: 467px;
                    background: radial-gradient(50.94% 44.66% at 49.86% 50.14%, rgba(0, 0, 0, 0.14) 0%, rgba(217, 217, 217, 0.00) 100%);
                }
            }
        }
    `;
}